import { useEffect } from "react"
import { RootState, useAppSelector } from "@/store/store.ts"

export function PwaTheme() {
  const theme = useAppSelector((state: RootState) => state.uiPreferences.theme)

  useEffect(() => {
    const html = document.documentElement
    const metaTheme = document.querySelector('meta[name="theme-color"]')

    if (theme === "dark") {
      html.classList.add("dark")
      metaTheme?.setAttribute("content", "#30303000")
    } else {
      html.classList.remove("dark")
      metaTheme?.setAttribute("content", "#e6e6e600")
    }
  }, [theme])

  return null
}
